import { render, staticRenderFns } from "./payGroup_Intro.vue?vue&type=template&id=226bdf17&scoped=true"
import script from "./payGroup_Intro.vue?vue&type=script&lang=js"
export * from "./payGroup_Intro.vue?vue&type=script&lang=js"
import style0 from "./payGroup_Intro.vue?vue&type=style&index=0&id=226bdf17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226bdf17",
  null
  
)

export default component.exports